import React from 'react';
import { STRINGS } from 'config';
import request from 'superagent';
import { toast } from '@econsult/econsult-ui/dist/components/Toast';
import { ErrorToast, SuccessToast } from 'components/Toast';

const { API: { PRACTICE_URL } } = STRINGS;

export const getErrorMessage = (method, error) => (
  `Unable to ${method} closing time behaviour. Please ${error.status === 401 ? 'refresh the page and ' : ''}try again.`
);

export const handleError = method => error => {
  const toastText = getErrorMessage(method, error);
  toast.error(<ErrorToast message={toastText} />, { id: false, autoClose: 12_000, icon: false });
  return false;
};

export const getClosingTimeBehaviour = practiceId => (
  request
    .get(`${PRACTICE_URL}/${practiceId}/closing-time-behaviour`)
    .withCredentials()
    .retry(3)
    .then(response => response.body.closingTimeBehaviour)
    .catch(handleError('get'))
);

export const saveClosingTimeBehaviour = (practiceId, closingTimeBehaviour) => (
  request
    .post(`${PRACTICE_URL}/${practiceId}/closing-time-behaviour`)
    .withCredentials()
    .retry(3)
    .send({ closingTimeBehaviour })
    .then(() => {
      toast(<SuccessToast message="Closing time behaviour saved successfully" />);
      return true;
    })
    .catch(handleError('save'))
);
